import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ICONS } from '@app/styles';
import { Renderer_DataField_Value } from '../../../../Renderer_DataFieldV2/Renderer_DataField_Value.js';
import { Renderer_DataField_Raw } from '../../../../Renderer_DataFieldV2/Renderer_DataField_Raw.js';
export const AdvisorWizardTree_VariableRenderer = (props) => {
    const editable = props.item.editable.editProp(0, {});
    //Variable can only be removed if it's:
    // 1. not connected to an actual finding
    // 2. not a common form variable
    // 3. the step isn't disabled
    const canRemove = !editable.item.existingFindingId && !props.item.isCommon && !props.item.disabled;
    return _jsxs(_Fragment, { children: [renderInput(props, editable), canRemove && _jsx(ICONS.advisor_avn_close.component, { className: 'node-remove-icon', onClick: e => {
                    e.stopPropagation();
                    editable.delete();
                } })] });
};
const renderInput = (props, editable) => {
    const isChiefComplaint = editable.item.isChiefComplaint;
    if (props.item.inputMethod === 'value')
        return _jsx(Renderer_DataField_Value, { disabled: props.item.disabled, variableId: props.item.id, allowUnknown: props.item.isCommon, selectedValueId: editable.item.valueId, isChiefComplaint: isChiefComplaint, onValueSelected: valueId => {
                if (!valueId)
                    editable.updateObj({ valueId, attributes: undefined });
                else
                    editable.updateObj({ valueId });
            }, toggleChiefComplaint: () => {
                editable.updateObj({ isChiefComplaint: !isChiefComplaint });
            } });
    if (props.item.inputMethod === 'raw')
        return _jsx(Renderer_DataField_Raw, { disabled: props.item.disabled, variableId: props.item.id, value: editable.item.rawValue, isChiefComplaint: isChiefComplaint, onValue: rawValue => {
                if (!rawValue)
                    editable.updateObj({ rawValue, attributes: undefined });
                else
                    editable.updateObj({ rawValue });
            }, toggleChiefComplaint: () => {
                editable.updateObj({ isChiefComplaint: !isChiefComplaint });
            } });
};
//# sourceMappingURL=variable-renderer.js.map